module.exports = __webpack_public_path__ + "static/img/target_2.b69026f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/target_2.png
// module id = gVUJ
// module chunks = 1